import React, { useEffect, useCallback, useContext } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Drawer } from '@mui/material';

import { SocketHelper } from '../helpers';
import { AuthenticationService, MessagesService } from '../services';
import { UnreadContext, UserContext } from '../contexts';
import NavBar from '../components/NavBar';

const SideBar = ({ window, mobileOpen, handleDrawerToggle }) => {
  const theme = useTheme();

  const container = window !== undefined ? () => window().document.body : undefined;

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { messagesCount, setMessagesCount } = useContext(UnreadContext);

  const { currentUser, isSuperAdmin } = useContext(UserContext);

  const { messagingCenter } = currentUser?.permissions?.administration ?? {};

  useEffect(() => {
    const fetchData = async () => {
      if (AuthenticationService.isLoggedIn() && (messagingCenter?.view || isSuperAdmin)) {
        const data = await MessagesService.count();
        setMessagesCount(data);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messagingCenter?.view, isSuperAdmin]);

  const onMessageReceivedHandler = useCallback(async () => {
    setMessagesCount(messagesCount + 1);
  }, [setMessagesCount, messagesCount]);

  useEffect(() => {
    if (AuthenticationService.isLoggedIn() && (messagingCenter?.view || isSuperAdmin)) {
      const socket = SocketHelper.create();
      socket.on('admin_message', onMessageReceivedHandler);
      return () => {
        socket.disconnect();
      };
    }
  }, [isSuperAdmin, messagingCenter?.view, onMessageReceivedHandler]);

  return (
    <>
      <Drawer
        container={container}
        variant='temporary'
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: isMobile && mobileOpen ? 'block' : 'none',
        }}>
        {<NavBar logo={true} anchor='inherit' open={mobileOpen} handleDrawerToggle={handleDrawerToggle} />}
      </Drawer>
      <NavBar
        styles={{
          display: !isMobile ? 'block ' : 'none',
        }}
        anchor='inherit'
        open
      />
    </>
  );
};

export default SideBar;
